import { useUserContext } from '@/shared/features/user-context/presentation/hooks/useUserContext';
import { useMultivariateExperiment } from '@/shared/features/multivariateexperiment/presentation/hooks/useMultivariateExperiment';

export function usePlpCustomerCode(): string | undefined {
  const { userContext } = useUserContext();
  const { homePageVariant } = useMultivariateExperiment();
  const isPersonalizedPlp = homePageVariant === 'V4' || homePageVariant === 'V5';
  return isPersonalizedPlp ? (userContext?.userCode ?? undefined) : undefined;
}
